import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import '@mdi/font/css/materialdesignicons.min.css';

import configureStore from './store';
import ProductTheme from './styles/themes';
import Routes from './routes';
import ContainerApp from './components/ContainerApp';
import CustomScripts from './components/CustomScripts';
import AuthMonitor from './config/AuthMonitor';

const { store, persistor } = configureStore();

const App = () => (
  <Provider store={store}>
    <PersistGate loading={<p>loading...</p>} persistor={persistor}>
      <ProductTheme>
        <ContainerApp>
          <AuthMonitor />
          <Routes />
        </ContainerApp>
      </ProductTheme>
      <CustomScripts />
    </PersistGate>
  </Provider>
);

export default App;
